<mat-form-field style="width: 100%">
    <mat-label>Gruppe ausw&auml;hlen</mat-label>
    <mat-select [formControl]="selectCtrl" [compareWith]="compareGruppen">
        <mat-option *ngFor="let g of gruppen" [value]="g"
            >{{ g.bezeichnung }} - Alter: {{ g.alter_wochen }} W. - {{ g.stall }} - T: {{ g.anzahl_tiere }}</mat-option
        >
    </mat-select>
</mat-form-field>
